/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCodepen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m21.5 7.1-9-5c-.3-.2-.7-.2-1 0l-9 5c-.3.2-.5.5-.5.9v7c0 .3.2.6.4.8l9 6c.3.2.8.2 1.1 0l9-6c.3-.2.4-.5.4-.8V8c.1-.4-.1-.7-.4-.9zM12 12.3l-1.4-.8 1.4-.8 1.4.8zm1-3.4V4.7L19 8l-3.7 2.3zm-2 0-2.3 1.4L5 8l6-3.3zm-7 .9 2.8 1.7L4 13.2zm4.7 2.9 2.3 1.4v5.1L4.9 15zm4.3 1.4 2.3-1.4 3.9 2.4-6.2 4zm7-.9-2.8-1.7L20 9.8z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgCodepen as Codepen };
